import React, {useContext} from "react";
import { Home, User, LogOut } from "react-feather";
import { useNavigate, useLocation } from "react-router-dom"; // ADICIONADO useLocation
import Login from "../pages/Login";
import AppContext from "../api/AppContext";
const NavItem = ({ icon, text, active = false, isLogout = false, onClick }) => {
  const [hover, setHover] = React.useState(false);
  const styles = getNavItemStyles(active, isLogout, hover);

  return (
    <div
      style={styles.item}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onClick || (() => {})}
      role="button"
      tabIndex={0}
    >
      <span style={styles.icon}>{icon}</span>
      <span>{text}</span>
    </div>
  );
};

const MobileNavItem = ({ icon, text, active = false, isLogout = false, onClick }) => {
  const styles = getMobileNavItemStyles(active, isLogout);

  return (
    <div
      style={styles.item}
      onClick={onClick || (() => {})}
      role="button"
      tabIndex={0}
    >
      <span>{icon}</span>
      <span style={styles.text}>{text}</span>
    </div>
  );
};

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Pega a rota atual
  const isDesktop = window.innerWidth >= 768;
  const styles = getNavbarStyles(isDesktop);
  // const { logout, user } = useContext(AppContext);
  const { isAuthenticated, user, logout } = useContext(AppContext);
  const [isLoggingOut, setIsLoggingOut] = React.useState(false);

  const handleHomeClick = () => navigate("/");
  
  const handleProfileClick = () => {
    navigate(isAuthenticated ? "/member/perfil" : "/login");
  };

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  const isActiveHome = location.pathname === "/";

  if (!isAuthenticated) return null; // Não renderiza se não autenticado
//   const handleHomeClick = () => {
//     navigate("/"); // Redireciona para a página inicial
//   };
// const handleProfileClick = () => {
//     if (user) {
//       navigate("/profile");
//     } else {
//       navigate("/login");
//     }
//   };

//   const handleLogout = () => {
//     logout();
//     navigate('/login');
//   };

//   const isActiveHome = location.pathname === "/";
return (
    <>
      {/* Navbar Desktop */}
      <nav style={styles.desktopNavbar}>
        <div>
          <img style={styles.logo} src="/logo.png" alt="Logo" />
          <NavItem
            icon={<Home size={20} />}
            text="Início"
            active={isActiveHome}
            onClick={handleHomeClick}
          />
          <NavItem 
            icon={<User size={20} />} 
            text="Perfil" 
            onClick={()=>navigate("/member/perfil")}
          />
        </div>
        <div style={styles.logoutContainer}>
          <NavItem 
            icon={<LogOut size={20} />} 
            text="Sair" 
            isLogout={true} 
            onClick={handleLogout}
          />
        </div>
      </nav>

      {/* Navbar Mobile */}
      <nav style={styles.mobileNavbar}>
        <MobileNavItem
          icon={<Home size={24} />}
          text="Início"
          active={isActiveHome}
          onClick={handleHomeClick}
        />
        <MobileNavItem 
          icon={<User size={24} />} 
          text="Perfil" 
          onClick={handleProfileClick}
        />
        <MobileNavItem 
          icon={<LogOut size={24} />} 
          text="Sair" 
          isLogout={true} 
          onClick={handleLogout}
        />
      </nav>
    </>
  );
};

// === Estilos da Navbar ===
const getNavbarStyles = (isDesktop) => ({
  desktopNavbar: {
    display: isDesktop ? "flex" : "none",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: "#3871c1",
    color: "white",
    height: "100vh",
    width: "16rem",
    position: "fixed",
    left: 0,
    top: 0,
    padding: "1rem",
  },
  mobileNavbar: {
    display: isDesktop ? "none" : "flex",
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "#2563eb",
    color: "white",
    justifyContent: "space-around",
    alignItems: "center",
    padding: "0.5rem",
  },
  logo: {
    width: "100%",
    height: "116px",
    marginRight: "16px",
    objectFit: "contain",
    padding: "5px",
    display: "flex",
    paddingBottom: "2rem",
  },
  logoutContainer: {
    marginBottom: "1rem",
  },
});

// === Estilos dos Itens da Navbar ===
const getNavItemStyles = (active, isLogout, hover) => ({
  item: {
    display: "flex",
    alignItems: "center",
    padding: "0.75rem",
    borderRadius: "0.5rem",
    marginBottom: "0.5rem",
    cursor: "pointer",
    backgroundColor: active ? "#1d4ed8" : "transparent",
    color: isLogout ? "#fecaca" : "white",
    ...(hover && !active && {
      backgroundColor: isLogout ? "#ef4444" : "#3b82f6",
      ...(isLogout && { color: "white" }),
    }),
    transition: "background-color 0.2s ease, color 0.2s ease",
  },
  icon: {
    marginRight: "0.75rem",
  },
});

const getMobileNavItemStyles = (active, isLogout=true) => ({
  item: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "0.5rem",
    borderRadius: "0.5rem",
    cursor: "pointer",
    backgroundColor: active ? "#1d4ed8" : "transparent",
    color: isLogout ? "#fecaca" : "white",
    transition: "background-color 0.2s ease, color 0.2s ease",
  },
  text: {
    fontSize: "0.75rem",
    marginTop: "0.25rem",
  },
});

export default Navbar;